import { render, staticRenderFns } from "./ProcedureItems.vue?vue&type=template&id=29f4069e&scoped=true"
import script from "./ProcedureItems.vue?vue&type=script&lang=js"
export * from "./ProcedureItems.vue?vue&type=script&lang=js"
import style0 from "./ProcedureItems.vue?vue&type=style&index=0&id=29f4069e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f4069e",
  null
  
)

export default component.exports